import { apim } from "@/constants/api"
import { ACI_PAYMENT_CHECKOUT_ENDPOINT } from "@/constants/routes"
import { CORE_GLOBAL_CONFIG_URL } from "@/constants"
import { getAemServerAxiosInstance } from "@/services/server/aem.server"

import { getCartIdParams } from "@/utils/cart"

export const getCheckoutIdApi = async () => {
  const { activeCartId = "" } = getCartIdParams()
  const url = `${ACI_PAYMENT_CHECKOUT_ENDPOINT}?cartId=${activeCartId}&pm=pp`
  const { data: { id = "" } = {} } = await apim.post(url)
  return id
}

export const callCoreConfigApi = async (url = "", locale = "") => {
  const urlPathWithoutParams = url?.split("?")[0] ?? `/${locale}`
  const serverAemApi = getAemServerAxiosInstance()

  try {
    const { data = {} } = await serverAemApi({
      url: `${CORE_GLOBAL_CONFIG_URL}?caConfig=true&path=/${locale}${urlPathWithoutParams}`,
      method: "GET",
    })
    return { data }
  } catch (error) {
    const {
      response: {
        config: { headers, url = "" } = {},
        status = 500,
        statusText = "",
      } = {},
    } = error

    return { error: { headers, statusText, status, url } }
  }
}
